"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var ExpanderDiv = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: 100%;\n\tmax-height: 0px;\n\theight: auto;\n\toverflow: hidden;\n\ttransition: max-height ease 0.5s;\n\t@media print {\n\t\tmax-height: unset !important;\n\t\ttransition: none !important;\n\t\tbackground-color: transparent !important;\n\t}\n"])));
var ExpanderDivHeight = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: 100%;\n\theight: auto;\n"])));

var Expander = function Expander(_ref) {
  var children = _ref.children,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? 1000 : _ref$maxHeight,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      expanderRef = _ref.expanderRef;

  var _react_1$default$useS = react_1.default.useState(expanded),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      open = _react_1$default$useS2[0],
      setOpen = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(0),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      calculatedHeight = _react_1$default$useS4[0],
      setCalculatedHeight = _react_1$default$useS4[1];

  react_1.default.useImperativeHandle(expanderRef, function () {
    return {
      open: function open() {
        var _a;

        setCalculatedHeight((_a = heightRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight);
        setOpen(true);
      },
      close: function close() {
        setOpen(false);
      }
    };
  });
  var heightRef = react_1.default.createRef();
  react_1.default.useEffect(function () {
    var _a;

    if (heightRef) {
      setCalculatedHeight((_a = heightRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight);
    }
  }, []);
  return (0, jsx_runtime_1.jsx)(ExpanderDiv, {
    css: (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\tmax-height: ", ";\n\t\t\t"])), open ? calculatedHeight + maxHeight + "px" : "0px"),
    children: (0, jsx_runtime_1.jsx)(ExpanderDivHeight, {
      ref: heightRef,
      children: children
    })
  });
};

exports.default = Expander;